import { render, staticRenderFns } from "./CommunicationProcedures.vue?vue&type=template&id=ae0cabaa&scoped=true&"
import script from "./CommunicationProcedures.vue?vue&type=script&lang=js&"
export * from "./CommunicationProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0cabaa",
  null
  
)

export default component.exports